/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.containers.HomePage.header',
    defaultMessage: 'Dashboard',
  },
  greeting: {
    id: 'app.containers.HomePage.greeting',
    defaultMessage: 'Hello {firstName},',
  },
  welcomeToTenant: {
    id: 'app.containers.HomePage.welcomeToTenant',
    defaultMessage: 'Welcome to {projectName}!',
  },
  emergency: {
    id: 'app.containers.HomePage.emergency',
    defaultMessage: 'Emergency situation',
  },
  pleaseReportYourStatus: {
    id: 'app.containers.HomePage.pleaseReportYourStatus',
    defaultMessage:
      'We want to make sure you are safe! Please report your status.',
  },
  reportStatus: {
    id: 'app.containers.HomePage.reportStatus',
    defaultMessage: 'report status',
  },
});
